<script>
export default {
  name: 'FilialSegmentationIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24,
    },
    color: {
      type: String,
      default: '#8E8E8E',
    },
  },
  computed: {
    // ID único por instância (this._uid é garantido único por componente Vue) —
    // o id fixo original (copiado de export do Figma) colide quando o mesmo
    // ícone renderiza mais de uma vez na mesma página.
    maskId() {
      return `mask0_2661_51327_${this._uid}`
    },
  },
}
</script>

<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="7" y="6" width="11" height="11" :fill="color" />
    <path
      d="M18.5408 4.17001L13.0408 2.11001C12.4708 1.90001 11.5408 1.90001 10.9708 2.11001L5.47078 4.17001C4.41078 4.57001 3.55078 5.81001 3.55078 6.94001V15.04C3.55078 15.85 4.08078 16.92 4.73078 17.4L10.2308 21.51C11.2008 22.24 12.7908 22.24 13.7608 21.51L19.2608 17.4C19.9108 16.91 20.4408 15.85 20.4408 15.04V6.94001C20.4508 5.81001 19.5908 4.57001 18.5408 4.17001ZM12.0008 16.25C9.38078 16.25 7.25078 14.12 7.25078 11.5C7.25078 8.88001 9.38078 6.75001 12.0008 6.75001C14.6208 6.75001 16.7508 8.88001 16.7508 11.5C16.7508 14.12 14.6208 16.25 12.0008 16.25Z"
      :fill="color"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M15.345 12.9815L12.5 14.3035V10.9455L15.5 9.55196V12.7695C15.5 12.8565 15.441 12.9375 15.345 12.9815ZM8.65154 12.982C8.55704 12.938 8.49904 12.857 8.50004 12.766V9.55196L11.5 10.9455V14.3045L8.65154 12.982ZM11.8535 7.53196C11.899 7.51046 11.9495 7.49996 12 7.49996C12.05 7.49996 12.1005 7.51046 12.146 7.53196L14.8105 8.76896L12 10.075L9.18904 8.76896L11.8535 7.53196ZM16.328 8.62946C16.3265 8.62546 16.327 8.62096 16.325 8.61696C16.3235 8.61296 16.3195 8.61046 16.317 8.60646C16.294 8.56846 16.266 8.53496 16.2395 8.49996C16.224 8.48296 16.2115 8.46396 16.1945 8.44946C16.077 8.31146 15.9385 8.18996 15.7665 8.11046L12.5665 6.62396C12.566 6.62396 12.5655 6.62396 12.5655 6.62346C12.206 6.45746 11.7935 6.45796 11.433 6.62396L8.23454 8.10996C8.06254 8.18946 7.92354 8.31046 7.80604 8.44846C7.78754 8.46396 7.77404 8.48496 7.75754 8.50346C7.73154 8.53696 7.70504 8.56946 7.68304 8.60546C7.68054 8.60996 7.67654 8.61296 7.67454 8.61696C7.67254 8.62146 7.67304 8.62596 7.67104 8.63046C7.56554 8.81146 7.50004 9.01496 7.50004 9.22896V12.7625C7.49604 13.2375 7.78204 13.6795 8.22904 13.8885L11.4285 15.3745C11.6095 15.459 11.8035 15.501 11.998 15.501C12.192 15.501 12.386 15.459 12.5665 15.375L15.765 13.889C16.211 13.683 16.4995 13.244 16.5 12.77V9.22846C16.4995 9.01446 16.434 8.81096 16.328 8.62946Z"
      :fill="color"
    />
    <mask
      :id="maskId"
      style="mask-type: alpha"
      maskUnits="userSpaceOnUse"
      x="7"
      y="6"
      width="10"
      height="10"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M15.345 12.9815L12.5 14.3035V10.9455L15.5 9.55196V12.7695C15.5 12.8565 15.441 12.9375 15.345 12.9815ZM8.65154 12.982C8.55704 12.938 8.49904 12.857 8.50004 12.766V9.55196L11.5 10.9455V14.3045L8.65154 12.982ZM11.8535 7.53196C11.899 7.51046 11.9495 7.49996 12 7.49996C12.05 7.49996 12.1005 7.51046 12.146 7.53196L14.8105 8.76896L12 10.075L9.18904 8.76896L11.8535 7.53196ZM16.328 8.62946C16.3265 8.62546 16.327 8.62096 16.325 8.61696C16.3235 8.61296 16.3195 8.61046 16.317 8.60646C16.294 8.56846 16.266 8.53496 16.2395 8.49996C16.224 8.48296 16.2115 8.46396 16.1945 8.44946C16.077 8.31146 15.9385 8.18996 15.7665 8.11046L12.5665 6.62396C12.566 6.62396 12.5655 6.62396 12.5655 6.62346C12.206 6.45746 11.7935 6.45796 11.433 6.62396L8.23454 8.10996C8.06254 8.18946 7.92354 8.31046 7.80604 8.44846C7.78754 8.46396 7.77404 8.48496 7.75754 8.50346C7.73154 8.53696 7.70504 8.56946 7.68304 8.60546C7.68054 8.60996 7.67654 8.61296 7.67454 8.61696C7.67254 8.62146 7.67304 8.62596 7.67104 8.63046C7.56554 8.81146 7.50004 9.01496 7.50004 9.22896V12.7625C7.49604 13.2375 7.78204 13.6795 8.22904 13.8885L11.4285 15.3745C11.6095 15.459 11.8035 15.501 11.998 15.501C12.192 15.501 12.386 15.459 12.5665 15.375L15.765 13.889C16.211 13.683 16.4995 13.244 16.5 12.77V9.22846C16.4995 9.01446 16.434 8.81096 16.328 8.62946Z"
        fill="white"
      />
    </mask>
    <g :mask="`url(#${maskId})`">
      <rect x="6" y="5" width="12" height="12" fill="white" />
    </g>
  </svg>
</template>
